// ============================================
// ALERT COMPONENT
// ============================================

import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';
import styles from './Alert.module.css';

type AlertVariant = 'info' | 'success' | 'warning' | 'error';

interface AlertProps {
  variant?: AlertVariant;
  title?: string;
  children: React.ReactNode;
}

const icons: Record<AlertVariant, React.ReactNode> = {
  info: <Info size={20} />,
  success: <CheckCircle size={20} />,
  warning: <AlertCircle size={20} />,
  error: <XCircle size={20} />,
};

export function Alert({ variant = 'info', title, children }: AlertProps) {
  return (
    <div className={`${styles.alert} ${styles[variant]}`}>
      <span className={styles.icon}>{icons[variant]}</span>
      <div className={styles.content}>
        {title && <span className={styles.title}>{title}</span>}
        <span className={styles.message}>{children}</span>
      </div>
    </div>
  );
}
